// src/components/wellfinder/cameraFocus.js
//
// Shared camera helper for WellFinder well-click focus. One helper, two call
// sites (the map feature click in WellLayer and the list-row click in
// WellFinderPanel) so the zoom floor and the RRC-panel left-shift can never
// drift apart again.
//
// The RRC enrichment panel (WellInfoPanel) is a 340px ABSOLUTE OVERLAY pinned to
// the right — the map container does NOT shrink when it opens, so any centering
// compensation has to come from the camera. We pass padding.right so the well
// lands centered in the visible area LEFT of the panel, but only when the panel
// will actually open (a detected well with a real RRC link).

// Zoom floor applied on every well click. Math.max floor semantics: a click must
// never zoom a reviewer back out of a closer view they've already set up.
export const WELL_FOCUS_ZOOM = 16.5;

// Right-side compensation, in px. Keep in sync with WellInfoPanel's w-[340px].
export const RRC_PANEL_WIDTH = 340;

// Guard against operating on a destroyed / mid-teardown map. Mirrors the guard
// used throughout WellLayer, which imports this so there is a single copy.
export function safeMapOp(map, fn) {
  try {
    if (!map || !map.getStyle?.()) return;
    fn(map);
  } catch (e) {
    // map destroyed or mid-destruction — ignore
  }
}

// Ease the map to a clicked well.
//   coords        — [lng, lat]
//   panelWillOpen — true when the RRC panel will cover the right 340px; pads the
//                   camera so the well centers in the visible area left of it.
//                   When false we pass { right: 0 } to reset any prior shift.
//   duration      — ease duration in ms.
export function focusWell(map, coords, { panelWillOpen = false, duration = 600 } = {}) {
  if (!map || !coords) return;
  safeMapOp(map, m => m.easeTo({
    center: coords,
    zoom: Math.max(m.getZoom(), WELL_FOCUS_ZOOM),   // floor: never zoom out
    padding: panelWillOpen ? { right: RRC_PANEL_WIDTH } : { right: 0 },
    duration,
  }));
}
